import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import LogoMarquee from "@/components/landing/LogoMarquee";
import HighlightsBottom from "@/components/landing/HighlightsBottom";
import About from "@/components/landing/About";
import CEO from "@/components/landing/CEO";
import Benefits from "@/components/landing/Benefits";
import Services from "@/components/landing/Services";
import Showreel from "@/components/landing/Showreel";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main className="bg-[#0A0A0A] text-white overflow-x-hidden">
      <Header />
      <Hero />
      <LogoMarquee />
      <HighlightsBottom />
      <About />
      <CEO />
      <Benefits />
      <Services />
      <Showreel />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
